/* Search hero story (/search), v5 2026-10-13 (+ dock hand-over 2026-10-14). Clips: journey (microscope → lens → the dish lights up, autoplays), fast (the
   same journey encoded at 3× for a search pressed mid-clip), hold (dish loop), zoom (dish → bacteria, 1.8×), bact (bacteria
   loop). Every switch pre-starts the next clip 0.6 s before the current one ends and crossfades (CSS opacity .6 s). Results
   come from the Section Rendering API during the clips and never show while a clip is still running: a refused play() lets
   the running clip finish, then everything stops on the bacteria still. Desktop: the hero folds into the compact band
   (v2–v4). Phones (Stefan 2026-10-13): no fold — the hero stays whole, the dive plays in the art area and the page then
   scrolls to the results. Since 2026-10-14 (Stefan: „when I click search or click any theme, instantly switch me down,
   ignore the animation") a search or a chip on a phone skips the dive: the bacteria loop crossfades in, the results come,
   the page scrolls to them at once. A results page served directly (menu/drawer search, a link) still starts on the lit
   dish and dives first, then scrolls. No pause button; still images under reduced motion / Save-Data (Stefan 2026-10-10/12). */
(() => {
  const hero = document.querySelector('.ipsr-hero');
  if (!hero || hero.dataset.motionReady) return;
  hero.dataset.motionReady = 'true';
  const NAMES = ['journey', 'fast', 'hold', 'zoom', 'bact'];
  const V = {};
  for (const k of NAMES) { V[k] = hero.querySelector('.ipsr-' + k); if (!V[k]) return; V[k].muted = V[k].defaultMuted = true; }
  const form = hero.querySelector('.ipsr-form');
  const input = form ? form.querySelector('input[name="q"]') : null;
  const results = document.getElementById('vysledky');
  const sectionId = hero.dataset.sectionId || '';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 900px)');
  const connection = navigator.connection;
  const FADE = 600;     // ms, = the CSS opacity transition
  const PRE = 0.6;      // s before a clip's end the next clip starts underneath
  const served = hero.classList.contains('is-compact');   // the page came with results (menu/drawer search, a link, reload)
  const isPhone = () => mobile.matches;
  let compact = served;
  let phase = served ? (isPhone() ? 'zoom' : 'bact') : 'journey';   // phones dive into the bacteria before anything else
  let variant = '';
  let visible = true;
  let searching = false;
  let clipsDone = served && !isPhone();
  let pending = null;
  let pushed = false;
  let settleTimer = 0;
  let scrolled = false;     // phones: the auto-scroll to the results ran
  let userMoved = false;    // phones: the visitor scrolled by hand since the search started → no auto-scroll
  const prefersStill = () => reduced.matches || Boolean(connection && connection.saveData);
  const rect = hero.getBoundingClientRect();
  visible = rect.bottom > 0 && rect.top < window.innerHeight;
  const NEXT = { journey: () => (searching ? 'zoom' : 'hold'), fast: () => 'zoom', zoom: () => 'bact', hold: () => null, bact: () => null };

  function load() {
    const next = isPhone() ? 'mobile' : 'desktop';
    if (variant === next) return;
    variant = next;
    for (const k of NAMES) { V[k].pause(); V[k].classList.remove('is-on'); V[k].preload = (k === phase || (k === 'bact' && served)) ? 'auto' : 'metadata'; V[k].src = V[k].dataset[next + 'Src']; }
  }
  let armed = false;
  function armRetry() {   // autoplay refused (power saving, Low Power Mode): the first interaction starts the current clip
    if (armed) return;
    armed = true;
    const kick = () => { armed = false; if (!document.hidden && visible && !prefersStill()) play(phase); };
    for (const ev of ['pointerdown', 'keydown', 'touchstart']) document.addEventListener(ev, kick, { once: true, passive: true });
  }
  function finishStill() {   // the animation cannot go on: stop on the bacteria still, then the results
    if (clipsDone) return;
    for (const o of NAMES) V[o].pause();
    hero.classList.add('ipsr-bact');
    if (isPhone()) { compact = true; hero.classList.add('is-compact'); for (const o of NAMES) V[o].classList.remove('is-on'); }   // fade to the still underneath
    phase = 'bact';
    clipsDone = true;
    reveal();
    if (served && isPhone()) scrollToResults();
  }
  function play(k) {
    const v = V[k]; v.preload = 'auto';
    const p = v.play();
    if (p) p.catch(() => {
      if (phase !== k) return;
      if (searching && !clipsDone) {   // never results over a running clip: let it finish, then stop on the still
        const running = NAMES.map((n) => V[n]).find((o) => o !== v && !o.paused && !o.ended && !o.loop);
        if (running) running.addEventListener('ended', finishStill, { once: true }); else finishStill();
        return;
      }
      armRetry();
    });
  }
  function settle(k) {   // after the crossfade: only the active clip keeps running
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(() => { for (const o of NAMES) if (o !== k) { V[o].classList.remove('is-on'); V[o].pause(); } }, FADE + 50);
  }
  function go(k) {       // start clip k underneath the current one; it fades in when it actually plays
    if (phase === k) return;
    phase = k;
    if (k === 'bact') { V.bact.preload = 'auto'; }
    play(k);
  }
  function update() {
    if (prefersStill()) { hero.classList.add('ipsr-still'); if (compact) hero.classList.add('ipsr-bact'); for (const k of NAMES) { V[k].pause(); V[k].classList.remove('is-on'); } return; }
    hero.classList.remove('ipsr-still');
    load();
    if (!visible || document.hidden) { for (const k of NAMES) V[k].pause(); return; }
    play(phase);
  }
  for (const k of NAMES) {
    const v = V[k];
    v.addEventListener('playing', () => {
      if (phase !== k) { v.pause(); return; }
      v.classList.add('is-on');
      settle(k);
      if (k === 'journey') { V.hold.preload = 'auto'; if (!isPhone()) { V.fast.preload = 'auto'; V.zoom.preload = 'auto'; } }   // phones fetch the search clips on the first touch
      if (k === 'zoom' || k === 'hold') { V.bact.preload = 'auto'; }
      if (k === 'bact') {
        hero.classList.add('ipsr-bact');
        if (!clipsDone) window.setTimeout(() => { clipsDone = true; reveal(); if (served && isPhone()) scrollToResults(); }, FADE + 100);
      }
    });
    const dead = () => { hero.classList.add('ipsr-still'); hero.classList.add('ipsr-bact'); if (searching && !clipsDone) finishStill(); };
    if (!v.loop) {
      v.addEventListener('timeupdate', () => {
        if (phase !== k || !v.duration) return;
        if (v.duration - v.currentTime <= PRE) { const n = NEXT[k](); if (n) go(n); }
      });
      v.addEventListener('ended', () => { if (phase === k) { const n = NEXT[k](); if (n) go(n); } });
      v.addEventListener('error', () => { if (phase === k) { const n = NEXT[k](); if (n) go(n); else dead(); } });
    } else {
      v.addEventListener('error', () => { if (phase === k) dead(); });
    }
  }
  function fastForward() {   // a search while the first clip runs: switch to the 3× encode at the matching moment
    const j = V.journey, f = V.fast;
    const seek = () => { try { f.currentTime = Math.min(j.currentTime / 3, Math.max(0, (f.duration || 3.3) - 0.15)); } catch (e) {} go('fast'); };
    if (f.readyState >= 1) seek(); else { f.preload = 'auto'; f.addEventListener('loadedmetadata', seek, { once: true }); f.load(); }
  }

  /* ---- the search flow ---- */
  const canFlow = () => Boolean(sectionId && results && window.fetch && window.DOMParser && !prefersStill());
  let cardObs = null;
  function observeCards() {   // injected result cards: reveal each as it enters (the shared engine only saw the served DOM)
    const cards = results.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!cards.length) return;
    if (prefersStill() || !('IntersectionObserver' in window)) { cards.forEach((c) => c.classList.add('is-in')); return; }
    if (!cardObs) cardObs = new IntersectionObserver((ents) => { ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); cardObs.unobserve(en.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    cards.forEach((c) => cardObs.observe(c));
  }
  function scrollToResults(force) {   // phones: once the clips are done (and the results are in), the page moves down to them
    if (!results || (!force && (scrolled || userMoved))) return;
    scrolled = true;
    if (!force && results.getBoundingClientRect().top <= 120) return;   // already reading there
    results.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
  }
  function applyResults(r) {
    results.innerHTML = r.html;
    const h1 = hero.querySelector('h1'); if (h1 && r.h1) h1.innerHTML = r.h1;
    const line = hero.querySelector('.ipsr-countline'); if (line) line.innerHTML = r.count || '';
    if (input) input.value = r.term;
    try { history.pushState({ ipsSearch: r.term }, '', r.url); pushed = true; } catch (e) {}
    document.title = 'Výsledky pro „' + r.term + '“ | iProbio';
    hero.classList.remove('is-searching');
    hero.dataset.performed = 'true';
    searching = false;
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      results.querySelectorAll('[data-reveal-group]').forEach((el) => el.classList.add('is-in'));
      observeCards();   // every card reveals on its own as it scrolls in (Stefan 2026-10-14)
    }));
    if (isPhone()) { scrolled = false; scrollToResults(true); }   // phones: every search lands on the new results at once (Stefan 2026-10-14 „instantly switch me down")
    else window.scrollTo({ top: 0, behavior: 'auto' });
  }
  function reveal() {
    if (!clipsDone || !pending) return;
    const r = pending; pending = null;
    if (compact || isPhone()) {   // compact band already, or a phone (no fold: the hero stays whole, the page scrolls)
      if (!compact) { compact = true; hero.classList.add('is-compact'); }
      applyResults(r);
      return;
    }
    hero.classList.add('is-folding');                       // copy fades out, the hero folds, copy fades back in its band layout
    window.setTimeout(() => {
      compact = true; hero.classList.add('is-compact');
      applyResults(r);
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => hero.classList.remove('is-folding')));
    }, 260);
  }
  function runSearch(term) {
    term = (term || '').trim();
    if (!term) return;
    const url = location.pathname + '?q=' + encodeURIComponent(term);
    const fromDock = Boolean(form && form.dataset.ipsFromDock === '1');   // handed over by the sticky dock: the hero is off screen
    if (form) delete form.dataset.ipsFromDock;
    pending = null;
    searching = true;
    userMoved = false;
    scrolled = false;
    hero.classList.add('is-searching');
    if (fromDock || isPhone()) { clipsDone = true; if (phase !== 'bact') go('bact'); }   // phones (Stefan 2026-10-14) and dock searches: no dive — straight to the bacteria loop and the results
    else if (phase === 'bact') { clipsDone = true; }                  // the bacteria already run: the results just swap
    else if (phase === 'zoom') { clipsDone = false; }                 // mid-dive: wait for the bacteria
    else {
      clipsDone = false;
      if (phase === 'journey') fastForward();
      else if (phase === 'hold') go('zoom');
    }
    // phones: nothing scrolls now — the search field stays exactly where it is while the dive plays above it (Stefan 2026-10-13);
    // the page moves only once the results are in, down to them.
    fetch(url + '&section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then((res) => { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const box = doc.getElementById('vysledky');
        if (!box) throw new Error('no results box');
        const h1 = doc.querySelector('.ipsr-hero h1');
        const line = doc.querySelector('.ipsr-hero .ipsr-countline');
        pending = { html: box.innerHTML, h1: h1 ? h1.innerHTML : '', count: line ? line.innerHTML : '', url: url, term: term, dock: fromDock };
        reveal();
      })
      .catch(() => { window.location.assign(url); });
  }
  const warm = () => { V.fast.preload = 'auto'; V.zoom.preload = 'auto'; V.bact.preload = 'auto'; };   // the search clips, on intent
  if (form && input) {
    input.addEventListener('focus', warm, { once: true });
    document.addEventListener('submit', (e) => {
      if (e.target !== form || !canFlow() || !input.value.trim()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      input.blur();   // phones: the keyboard goes; the field itself does not move
      runSearch(input.value);
    }, true);
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest ? e.target.closest('.ips-chip') : null;
    if (!a || !canFlow() || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    let term = '';
    try { term = new URL(a.href, location.href).searchParams.get('q') || ''; } catch (err) {}
    if (!term) return;
    e.preventDefault(); e.stopImmediatePropagation();
    runSearch(term);
  }, true);
  window.addEventListener('popstate', () => { if (pushed) window.location.reload(); });
  for (const ev of ['touchstart', 'pointerdown']) document.addEventListener(ev, warm, { once: true, passive: true });   // phones: a chip tap finds the clips ready
  for (const ev of ['touchmove', 'wheel']) document.addEventListener(ev, () => { userMoved = true; }, { passive: true });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); }).observe(hero);
  }
  reduced.addEventListener('change', update);
  mobile.addEventListener('change', update);
  if (connection && connection.addEventListener) connection.addEventListener('change', update);
  document.addEventListener('visibilitychange', update);
  update();
})();
